/* tslint:disable */
/* eslint-disable */
/**
 * LWM portal
 * Lamb-Weston Meijer Portal API documentation
 *
 * The version of the OpenAPI document: 3.3.10
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CloseDockOutputDTO } from '../model';
// @ts-ignore
import { GetAvailabilityOutputDTO } from '../model';
// @ts-ignore
import { HTTPValidationError } from '../model';
// @ts-ignore
import { OpenDockOutputDTO } from '../model';
// @ts-ignore
import { ReadLocationResponse } from '../model';
// @ts-ignore
import { SaveLocationRequest } from '../model';
// @ts-ignore
import { SaveLocationResponse } from '../model';
// @ts-ignore
import { WriteDockStateRequest } from '../model';
/**
 * LocationApi - axios parameter creator
 * @export
 */
export const LocationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Close Dock
         * @param {string} locationId 
         * @param {string} dockId 
         * @param {WriteDockStateRequest} writeDockStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeDockDockschedulingLocationsLocationIdDocksDockIdClosePut: async (locationId: string, dockId: string, writeDockStateRequest: WriteDockStateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('closeDockDockschedulingLocationsLocationIdDocksDockIdClosePut', 'locationId', locationId)
            // verify required parameter 'dockId' is not null or undefined
            assertParamExists('closeDockDockschedulingLocationsLocationIdDocksDockIdClosePut', 'dockId', dockId)
            // verify required parameter 'writeDockStateRequest' is not null or undefined
            assertParamExists('closeDockDockschedulingLocationsLocationIdDocksDockIdClosePut', 'writeDockStateRequest', writeDockStateRequest)
            const localVarPath = `/dockscheduling/locations/{location_id}/docks/{dock_id}/close`
                .replace(`{${"location_id"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"dock_id"}}`, encodeURIComponent(String(dockId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(writeDockStateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Location
         * @param {SaveLocationRequest} saveLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocationDockschedulingLocationsPost: async (saveLocationRequest: SaveLocationRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveLocationRequest' is not null or undefined
            assertParamExists('createLocationDockschedulingLocationsPost', 'saveLocationRequest', saveLocationRequest)
            const localVarPath = `/dockscheduling/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Location
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocationDockschedulingLocationsLocationIdDelete: async (locationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('deleteLocationDockschedulingLocationsLocationIdDelete', 'locationId', locationId)
            const localVarPath = `/dockscheduling/locations/{location_id}`
                .replace(`{${"location_id"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Availability
         * @param {string} locationId 
         * @param {string} date Date for which to check availability
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailabilityDockschedulingLocationsLocationIdAvailabilityGet: async (locationId: string, date: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getAvailabilityDockschedulingLocationsLocationIdAvailabilityGet', 'locationId', locationId)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('getAvailabilityDockschedulingLocationsLocationIdAvailabilityGet', 'date', date)
            const localVarPath = `/dockscheduling/locations/{location_id}/availability`
                .replace(`{${"location_id"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substr(0,10) :
                    date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Location
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationDockschedulingLocationsLocationIdGet: async (locationId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getLocationDockschedulingLocationsLocationIdGet', 'locationId', locationId)
            const localVarPath = `/dockscheduling/locations/{location_id}`
                .replace(`{${"location_id"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Locations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationsDockschedulingLocationsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/dockscheduling/locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Open Dock
         * @param {string} locationId 
         * @param {string} dockId 
         * @param {WriteDockStateRequest} writeDockStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openDockDockschedulingLocationsLocationIdDocksDockIdOpenPut: async (locationId: string, dockId: string, writeDockStateRequest: WriteDockStateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('openDockDockschedulingLocationsLocationIdDocksDockIdOpenPut', 'locationId', locationId)
            // verify required parameter 'dockId' is not null or undefined
            assertParamExists('openDockDockschedulingLocationsLocationIdDocksDockIdOpenPut', 'dockId', dockId)
            // verify required parameter 'writeDockStateRequest' is not null or undefined
            assertParamExists('openDockDockschedulingLocationsLocationIdDocksDockIdOpenPut', 'writeDockStateRequest', writeDockStateRequest)
            const localVarPath = `/dockscheduling/locations/{location_id}/docks/{dock_id}/open`
                .replace(`{${"location_id"}}`, encodeURIComponent(String(locationId)))
                .replace(`{${"dock_id"}}`, encodeURIComponent(String(dockId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(writeDockStateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Location
         * @param {string} locationId 
         * @param {SaveLocationRequest} saveLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocationDockschedulingLocationsLocationIdPut: async (locationId: string, saveLocationRequest: SaveLocationRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('updateLocationDockschedulingLocationsLocationIdPut', 'locationId', locationId)
            // verify required parameter 'saveLocationRequest' is not null or undefined
            assertParamExists('updateLocationDockschedulingLocationsLocationIdPut', 'saveLocationRequest', saveLocationRequest)
            const localVarPath = `/dockscheduling/locations/{location_id}`
                .replace(`{${"location_id"}}`, encodeURIComponent(String(locationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationApi - functional programming interface
 * @export
 */
export const LocationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Close Dock
         * @param {string} locationId 
         * @param {string} dockId 
         * @param {WriteDockStateRequest} writeDockStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closeDockDockschedulingLocationsLocationIdDocksDockIdClosePut(locationId: string, dockId: string, writeDockStateRequest: WriteDockStateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CloseDockOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closeDockDockschedulingLocationsLocationIdDocksDockIdClosePut(locationId, dockId, writeDockStateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create Location
         * @param {SaveLocationRequest} saveLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLocationDockschedulingLocationsPost(saveLocationRequest: SaveLocationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveLocationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLocationDockschedulingLocationsPost(saveLocationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete Location
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLocationDockschedulingLocationsLocationIdDelete(locationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLocationDockschedulingLocationsLocationIdDelete(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Availability
         * @param {string} locationId 
         * @param {string} date Date for which to check availability
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailabilityDockschedulingLocationsLocationIdAvailabilityGet(locationId: string, date: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAvailabilityOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailabilityDockschedulingLocationsLocationIdAvailabilityGet(locationId, date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Location
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationDockschedulingLocationsLocationIdGet(locationId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReadLocationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationDockschedulingLocationsLocationIdGet(locationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List Locations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLocationsDockschedulingLocationsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReadLocationResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLocationsDockschedulingLocationsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Open Dock
         * @param {string} locationId 
         * @param {string} dockId 
         * @param {WriteDockStateRequest} writeDockStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openDockDockschedulingLocationsLocationIdDocksDockIdOpenPut(locationId: string, dockId: string, writeDockStateRequest: WriteDockStateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpenDockOutputDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openDockDockschedulingLocationsLocationIdDocksDockIdOpenPut(locationId, dockId, writeDockStateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Location
         * @param {string} locationId 
         * @param {SaveLocationRequest} saveLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLocationDockschedulingLocationsLocationIdPut(locationId: string, saveLocationRequest: SaveLocationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveLocationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLocationDockschedulingLocationsLocationIdPut(locationId, saveLocationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LocationApi - factory interface
 * @export
 */
export const LocationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationApiFp(configuration)
    return {
        /**
         * 
         * @summary Close Dock
         * @param {string} locationId 
         * @param {string} dockId 
         * @param {WriteDockStateRequest} writeDockStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeDockDockschedulingLocationsLocationIdDocksDockIdClosePut(locationId: string, dockId: string, writeDockStateRequest: WriteDockStateRequest, options?: any): AxiosPromise<CloseDockOutputDTO> {
            return localVarFp.closeDockDockschedulingLocationsLocationIdDocksDockIdClosePut(locationId, dockId, writeDockStateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Location
         * @param {SaveLocationRequest} saveLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocationDockschedulingLocationsPost(saveLocationRequest: SaveLocationRequest, options?: any): AxiosPromise<SaveLocationResponse> {
            return localVarFp.createLocationDockschedulingLocationsPost(saveLocationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Location
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocationDockschedulingLocationsLocationIdDelete(locationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteLocationDockschedulingLocationsLocationIdDelete(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Availability
         * @param {string} locationId 
         * @param {string} date Date for which to check availability
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailabilityDockschedulingLocationsLocationIdAvailabilityGet(locationId: string, date: string, options?: any): AxiosPromise<GetAvailabilityOutputDTO> {
            return localVarFp.getAvailabilityDockschedulingLocationsLocationIdAvailabilityGet(locationId, date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Location
         * @param {string} locationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationDockschedulingLocationsLocationIdGet(locationId: string, options?: any): AxiosPromise<ReadLocationResponse> {
            return localVarFp.getLocationDockschedulingLocationsLocationIdGet(locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Locations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocationsDockschedulingLocationsGet(options?: any): AxiosPromise<Array<ReadLocationResponse>> {
            return localVarFp.listLocationsDockschedulingLocationsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Open Dock
         * @param {string} locationId 
         * @param {string} dockId 
         * @param {WriteDockStateRequest} writeDockStateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openDockDockschedulingLocationsLocationIdDocksDockIdOpenPut(locationId: string, dockId: string, writeDockStateRequest: WriteDockStateRequest, options?: any): AxiosPromise<OpenDockOutputDTO> {
            return localVarFp.openDockDockschedulingLocationsLocationIdDocksDockIdOpenPut(locationId, dockId, writeDockStateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Location
         * @param {string} locationId 
         * @param {SaveLocationRequest} saveLocationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocationDockschedulingLocationsLocationIdPut(locationId: string, saveLocationRequest: SaveLocationRequest, options?: any): AxiosPromise<SaveLocationResponse> {
            return localVarFp.updateLocationDockschedulingLocationsLocationIdPut(locationId, saveLocationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationApi - object-oriented interface
 * @export
 * @class LocationApi
 * @extends {BaseAPI}
 */
export class LocationApi extends BaseAPI {
    /**
     * 
     * @summary Close Dock
     * @param {string} locationId 
     * @param {string} dockId 
     * @param {WriteDockStateRequest} writeDockStateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public closeDockDockschedulingLocationsLocationIdDocksDockIdClosePut(locationId: string, dockId: string, writeDockStateRequest: WriteDockStateRequest, options?: any) {
        return LocationApiFp(this.configuration).closeDockDockschedulingLocationsLocationIdDocksDockIdClosePut(locationId, dockId, writeDockStateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Location
     * @param {SaveLocationRequest} saveLocationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public createLocationDockschedulingLocationsPost(saveLocationRequest: SaveLocationRequest, options?: any) {
        return LocationApiFp(this.configuration).createLocationDockschedulingLocationsPost(saveLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Location
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public deleteLocationDockschedulingLocationsLocationIdDelete(locationId: string, options?: any) {
        return LocationApiFp(this.configuration).deleteLocationDockschedulingLocationsLocationIdDelete(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Availability
     * @param {string} locationId 
     * @param {string} date Date for which to check availability
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public getAvailabilityDockschedulingLocationsLocationIdAvailabilityGet(locationId: string, date: string, options?: any) {
        return LocationApiFp(this.configuration).getAvailabilityDockschedulingLocationsLocationIdAvailabilityGet(locationId, date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Location
     * @param {string} locationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public getLocationDockschedulingLocationsLocationIdGet(locationId: string, options?: any) {
        return LocationApiFp(this.configuration).getLocationDockschedulingLocationsLocationIdGet(locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Locations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public listLocationsDockschedulingLocationsGet(options?: any) {
        return LocationApiFp(this.configuration).listLocationsDockschedulingLocationsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Open Dock
     * @param {string} locationId 
     * @param {string} dockId 
     * @param {WriteDockStateRequest} writeDockStateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public openDockDockschedulingLocationsLocationIdDocksDockIdOpenPut(locationId: string, dockId: string, writeDockStateRequest: WriteDockStateRequest, options?: any) {
        return LocationApiFp(this.configuration).openDockDockschedulingLocationsLocationIdDocksDockIdOpenPut(locationId, dockId, writeDockStateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Location
     * @param {string} locationId 
     * @param {SaveLocationRequest} saveLocationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public updateLocationDockschedulingLocationsLocationIdPut(locationId: string, saveLocationRequest: SaveLocationRequest, options?: any) {
        return LocationApiFp(this.configuration).updateLocationDockschedulingLocationsLocationIdPut(locationId, saveLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
